import { motion } from 'framer-motion';
import React, { FC, useCallback, useState } from 'react';

import Button from '../../shared/buttonComponents/Button';
import SearchSVG from '../../shared/svg/SearchSVG';
import OutsideClickHandler from 'react-outside-click-handler';


interface LicenceListItem {
  name: string;
  selected?: boolean;
}

interface LicencePopupList {
  name: string;
  selected: boolean;
}

interface LicencePopupInterface {
  licenceList: LicenceListItem[];
  onClose: () => void;
  onSubmit: (selected: any) => void;
  title?: string;
}

const LicencesPopupList: FC<LicencePopupInterface> = ({ licenceList, onClose, onSubmit, title }): JSX.Element => {
  let licList = licenceList.sort((a, b) => a.name > b.name ? 1 : -1);

  const [list, setList] = useState(licList);
  const [listSelected, setListSelected] = useState(licenceList);

  const first = 'No License';
  list.sort(function (x, y) {
    return x.name === first ? -1 : y.name === first ? 1 : 0;
  });

  const [selectPreview, setSelectPreview] = useState('Nothing Selected');

  const handleSelect = useCallback((name, selected, preview = 'Nothing') => {
    setListSelected(state => {
      const res = state.map((s) => {
        if (s.name === name) {
          return {
            ...s,
            selected
          };
        }

        return {
          ...s,
          selected: false
        };
      });

      setList(res);

      return res;
    });
  }, []);

  const handleSearch = useCallback((e) => {
    const reg = new RegExp(e.target.value, 'gi');

    setList(listSelected.filter((item) => !!item.name.match(reg)));
  }, [listSelected]);

  const handleSubmit = useCallback(() => {
    const selected = list.filter(c => c.selected);
    if (selected.length === 0) {
      return;
    }

    onSubmit(selected[0]);
  }, [list, onSubmit]);

  // const noLicence = ['no License'];


  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        onClose();
      }}
    >
      <motion.div
        initial={{
          opacity: 0,
          scale: 0
        }}
        animate={{
          opacity: 1,
          scale: 1
        }}
        exit={{
          opacity: 0,
          scale: 0
        }}
        transition={{
          duration: 0.5
        }}
        className="licence-popup-list-container"
      >
        <div className="licence-popup">

          <div className="licence-popup-close">
            <img
              onClick={onClose}
              src={`${process.env.PUBLIC_URL}/assets/images/close-icon.png`}
              alt=""
            />
          </div>

          <div className="licence-popup-title">
            Select {title} license
          </div>

          <div className="licence-popup-search-box">
            <div className="licence-popup-search">
              <input
                onChange={handleSearch}
                placeholder="You can search here..."
                type="text"
              />
              <div className="search-icon">
                <SearchSVG/>
              </div>
            </div>
          </div>

          <div className='selected-items-box'>
            {selectPreview}
          </div>

          <div className="licence-popup-list">
            {list.map((licence, index) => (
              <div key={index} className="licence-box">
                <div className="licence-checkbox-box">
                  <input
                    onChange={() => handleSelect(
                      licence.name,
                      !licence.selected,
                      setSelectPreview(`${selectPreview === licence.name ? 'Nothing Selected' : licence.name}`)
                    )}
                    id={`checkbox-item-${index}`}
                    className="licence-checkbox"
                    type="checkbox"
                    checked={selectPreview === licence.name}
                  />
                  <label htmlFor={`checkbox-item-${index}`}/>
                </div>

                <div
                  onClick={() => handleSelect(
                    licence.name,
                    !licence.selected,
                    setSelectPreview(`${selectPreview === licence.name ? 'Nothing Selected' : licence.name}`)
                  )}
                  className="licence-title"
                >
                  {licence.name}
                </div>
              </div>
            ))}
          </div>
          <div className="licence-popup-button">
            <Button
              title="Next"
              onClick={handleSubmit}
              disabled={!(selectPreview !== 'Nothing Selected')}
            />
          </div>

        </div>

        <div className="licence-popup-mobile">
          <div className="licence-popup-close">
            <img
              onClick={onClose}
              src={`${process.env.PUBLIC_URL}/assets/images/X2x.png`}
              alt=""
            />
          </div>

          <div className="licence-popup-title">
            Select a licence
          </div>

          <div className="licence-popup-search-box">
            <div className="licence-popup-search">
              <input
                onChange={handleSearch}
                placeholder="You can search here..."
                type="text"
              />
              <div className="search-icon">
                <SearchSVG/>
              </div>
            </div>
          </div>

          <div className='selected-items-box-mobile'>
            {selectPreview}
          </div>

          <div className="licence-popup-list scroll-popup-mobile">
            {list.map((licence, index) => (
              <div key={index} className="licence-box">
                <div className="licence-checkbox-box">
                  <input
                    onChange={() => handleSelect(
                      licence.name,
                      !licence.selected,
                      setSelectPreview(`${selectPreview === licence.name ? 'Nothing Selected' : licence.name}`)
                    )}
                    id={`checkbox-item-${index}`}
                    className="licence-checkbox"
                    type="checkbox"
                    checked={selectPreview === licence.name}
                  />
                  <label htmlFor={`checkbox-item-${index}`}/>
                </div>

                <div
                  onClick={() => handleSelect(
                    licence.name,
                    !licence.selected,
                    setSelectPreview(`${selectPreview === licence.name ? 'Nothing Selected' : licence.name}`)
                  )}
                  className="licence-title"
                >
                  {licence.name}
                </div>
              </div>
            ))}
          </div>

          <div className="licence-popup-button">
            <Button
              title="Next"
              onClick={handleSubmit}
              disabled={!(selectPreview !== 'Nothing Selected')}
            />
          </div>

        </div>
      </motion.div>
    </OutsideClickHandler>
  );
};

// <motion.div
//   initial={{
//     opacity: 0,
//     scale: 0
//   }}
//   animate={{
//     opacity: 1,
//     scale: 1
//   }}
//   exit={{
//     opacity: 0,
//     scale: 0
//   }}
//   transition={{
//     duration: 0.5
//   }}
//   className="continents-popup-container"
// >
//   <div className="continents-popup">
//
//     <div className="licence-type-page-list">
//       {licences.map((licence: { name: string | number | null | undefined; }) => (
//         <SelectBox
//           key={licence.name}
//           title={licence.name as string}
//         />
//       ))}
//     </div>
//
//     <div className="continents-popup-button">
//       <Button
//         title="Next"
//         onClick={handleSubmit}
//       />
//     </div>
//   </div>
//
//     <div className="continents-popup-button">
//       <Button
//         title="Next"
//         onClick={handleSubmit}
//       />
//     </div>
// </motion.div>
//   );
// };

export default LicencesPopupList;
